define( [
	"./cssExpand"
], function( cssExpand ) {
	"use strict";

	return new RegExp( cssExpand.join( "|" ), "i" );
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/css/var/rboxStyle.js
// module id = 256
// module chunks = 0